import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const init = () => {

    var $swipers = $('.partnership-project .swiper-container');
    $swipers.each(function(i, el) {
        var $parent = $(el).closest('.partnership-project');
        new Swiper(el, {
            modules: [Navigation, Pagination],
            spaceBetween: 10,
            pagination: {
                el: $parent.find('.swiper-pagination')[0],
                clickable: true
            },
            navigation: {
                nextEl: $parent.find('.swiper-button-next')[0],
                prevEl: $parent.find('.swiper-button-prev')[0]
            },
            lazy: {
                loadOnTransitionStart: true
            }
        });
    });

}

export default init;
